module.exports = __webpack_public_path__ + "img/sun (1).4c437266.png";